// extracted by mini-css-extract-plugin
export default {"Gallery":"TeamGallery_Gallery__gEkrB"};